import { useContext, useState } from "react";
import PassingTestFooter from "./PassingTestFooter";
import { IQuestion } from "../Tests/types";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import PassingTestHeader from "./PassingTestHeader";
import QuestionsCardTest from "./Questions/QuestionsCardTest";
import { PassingTestContext } from "./passingTestContext";

const PassingTest = () => {
  const [countCorrectAnswers, setCountCorrectAnswers] = useState(0);
  const { questions, getAnswersResult } = useContext(PassingTestContext);
  const methods = useForm<IQuestion>();
  const { handleSubmit } = methods;

  const checkCorrectAnswers = (data: any) => {
    return questions?.map((question: IQuestion) => {
      return {
        id: question.ID,
        isRight: question.Answers.every(answer => !!answer.IsCorrect === !!data[answer.ID])
      };
    });
  };

  const onSubmit: SubmitHandler<IQuestion> = (data: any) => {
    const testResults = checkCorrectAnswers(data);
    getAnswersResult(data);
    setCountCorrectAnswers(testResults.filter((question: { id: string; isRight: boolean }) => question.isRight === true).length);
  };

  return (
    <div className="px-10 pt-10 pb-8 ">
      <PassingTestHeader />
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-[30px]">
            {questions?.map((question: IQuestion) => (
              <QuestionsCardTest key={question.ID} question={question} />
            ))}
          </div>
          <PassingTestFooter countCorrectAnswers={countCorrectAnswers} />
        </form>
      </FormProvider>
    </div>
  );
};

export default PassingTest;
